export default __webpack_public_path__ + "static/media/visaLogo.b5bd9602.png";